declare const window: Window &
  typeof globalThis & {
    env: {
      APM_URL?: string
      APM_ENABLED?: boolean
      APM_SERVICE_NAME?: string
    }
  }

const apmUrl = (() => {
  if (typeof window === 'undefined') return ''
  if (!window.env.APM_ENABLED) return
  if (window.env.APM_URL) return window.env.APM_URL

  return `https://${window.location.hostname}`
})()

export const APM_URL = apmUrl

export const APM_SERVICE_NAME =
  (typeof window !== 'undefined' && window.env.APM_SERVICE_NAME) || 'landing-mania'
